export const COUPON_ITEM_CLASS_NAME = 'coupon-item';
